function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    unlockScroll();
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);


// iPhone/iPad (iPadOS UA "Macintosh") + viewport ≤ 1024px
const __isIOSPhoneTabletMax1024 = () => {
  const ua = navigator.userAgent || '';
  const isIOS =
    /\b(iPad|iPhone|iPod)\b/i.test(ua) ||
    (/\bMacintosh\b/i.test(ua) && navigator.maxTouchPoints > 1);
  const vw = (window.visualViewport && window.visualViewport.width) || window.innerWidth || 0;
  return isIOS && vw <= 1024;
};

let __lockCount = 0;
let __lockY = 0;

const __ALLOW_SCROLL_SELECTOR = '#menu-drawer,#HeaderCountryMobileList';

let __activeScroller = null;
let __startY = 0;

const __onTouchStart = (e) => {
  __activeScroller = e.target.closest(__ALLOW_SCROLL_SELECTOR);
  if (__activeScroller) {
    __startY = e.touches[0].clientY;
  }
};

const __onTouchMove = (e) => {
  if (!__activeScroller) {
    e.preventDefault();
    return;
  }

  const el = __activeScroller;

  if (el.scrollHeight <= el.clientHeight) {
    e.preventDefault();
    return;
  }

  const currentY = e.touches[0].clientY;
  const dy = currentY - __startY;

  const atTop = el.scrollTop <= 0;
  const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;

  if ((atTop && dy > 0) || (atBottom && dy < 0)) {
    e.preventDefault();
  }
};

function lockScroll() {
  if (__lockCount++ > 0) return;

  __lockY = window.scrollY || window.pageYOffset || 0;

  document.body.classList.add('lockscroll');
  document.body.style.top = `-${__lockY}px`;
  document.documentElement.style.setProperty('--menu-drawer-top', `-${__lockY}px`);
  document.body.style.position = 'fixed';
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';

  if (__isIOSPhoneTabletMax1024()) {
    document.addEventListener('touchstart', __onTouchStart, { passive: false });
    document.addEventListener('touchmove', __onTouchMove, { passive: false });
  }
}

function unlockScroll() {
  if (--__lockCount > 0) return;

  if (__isIOSPhoneTabletMax1024()) {
    document.removeEventListener('touchstart', __onTouchStart, { passive: false });
    document.removeEventListener('touchmove', __onTouchMove, { passive: false });
    __activeScroller = null;
  }

  document.body.classList.remove('lockscroll');
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  document.documentElement.style.removeProperty('--menu-drawer-top');
  window.scrollTo(0, __lockY || 0);
}


class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');
    lockScroll();

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    unlockScroll();
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event?.code?.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    document.dispatchEvent(new CustomEvent('geoRedirectClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VerticalSliderComponent extends SliderComponent {
  constructor() {
    super();
    // Additional initialization for vertical slider
    this.setAttribute('orientation', 'vertical');
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientHeight > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
    this.slidesPerPage = Math.floor(
      (this.slider.clientHeight - this.sliderItemsToShow[0].offsetTop) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      top: position,
    });
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientHeight + this.slider.scrollTop - offset;
    return element.offsetTop + element.clientHeight <= lastVisibleSlide && element.offsetTop >= this.slider.scrollTop;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollTop + step * this.sliderItemOffset
        : this.slider.scrollTop - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }
}

customElements.define('vertical-slider', VerticalSliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    // this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  filterMedia() {
  // $('[thumbnail-color]').hide();
  // var selected_variant = this.currentVariant.featured_media?.alt;
  // var selected_attribute = '[thumbnail-color="' + selected_variant + '"]';

  // if (selected_variant !== undefined) {
  //   $(selected_attribute).show();
  // }
}

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      const lowStockOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant.inventory_quantity < 5 && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue, lowStockOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions, listOfLowStockOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        if (listOfLowStockOptions.includes(input.getAttribute('value'))) {
          input.innerText = window.variantStrings.lowstock_with_option.replace('[value]', input.getAttribute('value'));
        }else{
          input.innerText = input.getAttribute('value');
        }
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant?.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        const modelInfoSource = html.getElementById(
          `model-info-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const modelInfoDestination = document.getElementById(`model-info-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        if (modelInfoSource && modelInfoDestination) {
          modelInfoDestination.innerHTML = modelInfoSource.innerHTML;
          modelInfoDestination.classList.toggle('hidden', modelInfoSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
    const modelInfo = document.getElementById(`model-info-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
    if (modelInfo) modelInfo.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions, listOfLowStockOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
        if (listOfLowStockOptions.includes(input.getAttribute('value'))) {
          input.classList.add('lowstock');
        } else {
          input.classList.remove('lowstock');
        }
      } else {
        input.classList.remove('lowstock')
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const selectedRadio = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      return selectedRadio ? selectedRadio.value : null;
    });
    document.querySelectorAll('.product-gallery__media video').forEach(video => {
      if (!video.paused) {
        video.pause();
      }
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class NewsletterSubscriber extends HTMLElement {
  static emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  static keyFormIdBeforeChallenge = 'newsletter_form_id_before_challenge';

  constructor() {
    super();

    this.emailInput = this.querySelector('input[name="contact[email]"]');
    this.subscribeButton = this.querySelector('button');
    this.subscriptionMessagesContainer = this.querySelector('.messages .message');
    this.subscriptionErrorMessageElement = this.querySelector('.error-container .message-text');
    this.validationMessageElement = this.querySelector('[data-role="validation-message"]');
    this.form = this.querySelector('form#ContactFooter');
  }

  connectedCallback() {
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.handleFormSubmit();
    });
    this.handleFormLoad();
  }

  handleFormSubmit() {
    this.togglerSubscribeMessage(false);

    if (this.isEmailValid()) {
      this.validationMessageElement.innerText = '';
      this.emailInput.classList.remove('invalid');

      this.toggleFormElementsDisabled(true);

      const form = document.getElementById('ContactFooter');
      const email = form.querySelector('input[name="contact[email]"]').value;
      const lang = document.querySelector('input[name="locale_code"]').value;

      // Define the new endpoint for subscription
      const subscriptionEndpoint =  window.subscriptionEndpoint;
      // AJAX call to custom endpoint for adding newsletter subscriber
      fetch(subscriptionEndpoint, {
        method: 'POST',
        body: JSON.stringify({  action: 'add-subscriber', email: email, lang: lang }),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        if (!response.ok) {
          // If response is not OK (e.g., 400 Bad Request), handle the error
          return response.json().then(data => {
            throw data;
          });
        }
        return response.json();
      })
      .then(data => {
        if (data.success) {
          this.togglerSubscribeMessage(
            true,
            true,
            'Thank you for your subscription.'
          );
        }else if (!data.success) {
          this.togglerSubscribeMessage(
            true,
            false,
            'This email address is already subscribed.'
          );
        }
          else {
          throw new Error('Unexpected response format');
        }
      })
      .catch(data => {
        // console.log(data,88)
        this.togglerSubscribeMessage(
          true,
          false,
          (data?.message || 'This email address is already subscribed.')
        );
        this.toggleFormElementsDisabled(false);

      });
    } else {
      this.validationMessageElement.innerText = this.hasAttribute('data-invalid-email-error')
        ? this.getAttribute('data-invalid-email-error')
        : 'Email adress is invalid.';
      this.emailInput.classList.add('invalid');
    }
  }

  /**
   * Workaround for case subsribe with a subscribed email. This function will be useful when returned from /challenge page.
   */
  handleFormLoad() {
    const formIdBeforeChallenge = window.sessionStorage.getItem(NewsletterSubscriber.keyFormIdBeforeChallenge),
      searchParams = new URLSearchParams(window.location.search);

    if (formIdBeforeChallenge === this.form.id) {
      if (this.emailInput.value !== '' && searchParams.get('form_type') === 'customer') {
        searchParams.delete('contact[tags]');
        searchParams.delete('form_type');
        window.history.replaceState(null, '', window.location.pathname + (searchParams.size > 0 ? `?${searchParams.toString()}` : ''));

        this.togglerSubscribeMessage(
          true,
          false,
          (this.hasAttribute('data-subscribed-email-error') ? this.getAttribute('data-subscribed-email-error') : 'This email adress is already subscribed.')
        );

        if (this.hasAttribute('data-auto-scroll-into-view')) {
          this.form.scrollIntoView({behavior: 'smooth'});
        }
      } else if (searchParams.get('customer_posted')) {
        if (this.hasAttribute('data-auto-scroll-into-view')) {
          this.form.scrollIntoView({behavior: 'smooth'});
        }
      }

      if (window.location.pathname !== '/challenge') {
        window.sessionStorage.removeItem(NewsletterSubscriber.keyFormIdBeforeChallenge);
      }
    } else {
      this.togglerSubscribeMessage(false);
    }

    if (this.emailInput.value !== '' && formIdBeforeChallenge !== this.form.id) {
      this.emailInput.value = '';
    }
  }

  isEmailValid() {
    return NewsletterSubscriber.emailPattern.test(this.emailInput.value);
  }

  toggleFormElementsDisabled(isDisabled) {
    this.emailInput.disabled = isDisabled;
    this.subscribeButton.disabled = isDisabled;
  }

  togglerSubscribeMessage(isShown, isSuccess = true, message = '') {
    if (isShown) {
      if (isSuccess) {
        this.subscriptionErrorMessageElement.innerText = '';
        this.subscriptionMessagesContainer.classList.add('message-success');
        this.subscriptionMessagesContainer.classList.add('success');
      } else {
        this.subscriptionErrorMessageElement.innerText = message;
        this.subscriptionMessagesContainer.classList.add('message-error');
        this.subscriptionMessagesContainer.classList.add('error');
      }
    } else {
      this.subscriptionMessagesContainer.classList.remove('message-success');
      this.subscriptionMessagesContainer.classList.remove('success');
      this.subscriptionMessagesContainer.classList.remove('message-error');
      this.subscriptionMessagesContainer.classList.remove('error');
    }
  }
}

class ProductActionsSticky extends HTMLElement {
  constructor() {
    super();
    if(!this.closest('.wishlist-container')){
      this.initElement();
    }
    this.productActionsStickyBottom();
    window.addEventListener('scroll', this.productActionsStickyBottom);
    window.addEventListener('resize', this.productActionsStickyBottom)
  }

  initElement(){
    const title = document.querySelector('.product__info-container > .product__title');
    const titleInSticky = this.querySelector('.product__title');
    const badges = document.querySelector('.product__info-container [id*="flair_product_badges_labels"]');
    const price = document.querySelector('.product__info-container .product__price');
    const mqMobile = window.matchMedia('(max-width: 990px)');


    if (mqMobile.matches) {
      if(price){
        titleInSticky.after(price);
      }
      if(badges){
        titleInSticky.before(badges);
      }
    } else {
      if(this.querySelector('.product__price')){
        title.after(price);
      }
      if(this.querySelector('[id*="flair_product_badges_labels"]')){
        title.before(badges);
      }
    }

    mqMobile.addEventListener('change', (e) => {
      if (e.matches){
        if(price){
          titleInSticky.after(price);
        }
        if(badges){
          titleInSticky.before(badges);
        }
      } else {
        if(this.querySelector('.product__price')){
          title.after(price);
        }
        if(this.querySelector('[id*="flair_product_badges_labels"]')){
          title.before(badges);
        }
      }
    });
  }

  productActionsStickyBottom(){
    const productGalleryRect = document.querySelector('product-gallery').getBoundingClientRect(),
          productActions = document.querySelector('product-actions-sticky'),
          productActionsRect = productActions.getBoundingClientRect();
    if(productGalleryRect.bottom + 20 > window.innerHeight - productActionsRect.height){
      productActions.classList.add('sm-visibility-hidden');
    }else{
      productActions.classList.remove('sm-visibility-hidden');
    }
  }
}

customElements.define('product-actions-sticky', ProductActionsSticky);

customElements.define('newsletter-subscriber', NewsletterSubscriber);

document.querySelectorAll(".footer-menu-links.grid__item").forEach((footerBlock) => {
  const heading = footerBlock.querySelector(".footer-menu-links-heading");

  if (!heading) {
    footerBlock.classList.add("active");
    return;
  }

  heading.addEventListener("click", () => {
    footerBlock.classList.toggle("active");
  });
});

document.addEventListener('DOMContentLoaded', function() {
  var lazyloadImages = document.querySelectorAll('img.lazyload');
  var lazyloadObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var lazyloadImage = entry.target;
        lazyloadImage.src = lazyloadImage.dataset.src;
        lazyloadImage.classList.remove('lazyload');
        lazyloadObserver.unobserve(lazyloadImage);
      }
    });
  });

  lazyloadImages.forEach(function(lazyloadImage) {
    lazyloadObserver.observe(lazyloadImage);
  });
});

const currentURL = window.location.href;

// Kiểm tra xem URL có chứa chuỗi 'a/storelocator' hay không
if (currentURL.includes('a/storelocator')) {
  // Thực hiện các thao tác JavaScript ở đây
  document.addEventListener("DOMContentLoaded", function () {
    // Tạo đối tượng FormData và thêm dữ liệu cần gửi
    const formData = new FormData();
    formData.append('shopData', 'evisu-tw.myshopify.com');

    // Tạo đối tượng XMLHttpRequest
    const xhr = new XMLHttpRequest();

    // Thiết lập phương thức và URL
    xhr.open('POST', 'https://storelocator.metizapps.com/stores/storeDataGet', true);

    // Xử lý sự kiện khi yêu cầu hoàn thành
    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        // Xử lý dữ liệu nhận được tại đây
        const responseData = JSON.parse(xhr.responseText);

        const searchContentElement = document.querySelector('.col-lg-4.add_custom_size');

        const htmlSearchMenu =  '<ul id="search-menu">' +
                                  '<li class="search_filter" data-menu="filter_form">Filter</li>' +
                                  '<li class="search_keyword" data-menu="search_content">Search</li>'+
                                  '<li class="search_nearby selected" data-menu="nearby_form">Nearby</li>' +
                                '</ul>';
        const htmlSearchForm =  '<div id="search-form">' +
                                  '<div class="filter_form search_form" id="filter"><div class="country-select-wrapper"></div></div>' +
                                  '<div class="nearby_form search_form selected" id="near"><button type="button" id="search_nearby_button">Search Nearby Stores</button></div>' +
                                '</div>'

        searchContentElement.insertAdjacentHTML('afterbegin', htmlSearchForm);
        searchContentElement.insertAdjacentHTML('afterbegin', htmlSearchMenu);

        const filterForm = document.querySelector('.filter_form');
        const customSelectWrapper = document.querySelector('.country-select-wrapper');

        const data = responseData.data.result;
        const ulElement = document.createElement('ul');
        ulElement.classList.add('country-select-drop');
        ulElement.style.display = 'none';

        // Thêm một li mặc định với giá trị "destination"
        const defaultLiElement = document.createElement('li');
        defaultLiElement.textContent = "Destination";
        defaultLiElement.setAttribute('value', 'destination');
        ulElement.appendChild(defaultLiElement);

        let countryNames = {};
        data.forEach(function (item) {
          if (!countryNames[item.countryname.toLowerCase().replace(/\s/g, '')]) {
            // Nếu chưa tồn tại, thêm countryname vào đối tượng countryNames
            countryNames[item.countryname.toLowerCase().replace(/\s/g, '')] = true;

            // Tạo một phần tử li
            const liElement = document.createElement('li');

            // Đặt nội dung của a là countryname
            liElement.textContent = item.countryname;

            // Đặt giá trị của a là countryname
            liElement.setAttribute('value', item.countryname.toLowerCase().replace(/\s/g, ''));

            // Thêm li vào ul
            ulElement.appendChild(liElement);
          }
        });

        customSelectWrapper.innerHTML += '<a href="#" class="country-select-btn" tabindex="0">Destination</a>';
        customSelectWrapper.appendChild(ulElement);

        const searchNearbyButton = document.getElementById("search_nearby_button");
        const findMyLocationLink = document.getElementById("findmylocation");

        // Thêm sự kiện click cho button
        searchNearbyButton.addEventListener("click", function() {
          // Kích hoạt sự kiện click cho thẻ a
          findMyLocationLink.click();
        });

        const searchMenuItems = document.querySelectorAll('#search-menu li');
        // Lặp qua từng <li> và thêm sự kiện click
        searchMenuItems.forEach(function (item) {
          item.addEventListener('click', function() {
            document.querySelector('.filter_form').classList.remove('selected');
            document.querySelector('.nearby_form').classList.remove('selected');
            document.querySelector('.search_content').classList.remove('selected');

            searchMenuItems.forEach(function(menuItem) {
              // Kiểm tra xem menuItem có phải là phần tử được click hay không
              if (menuItem === item) {
                // Nếu là phần tử được click, thêm class 'selected'
                menuItem.classList.add('selected');
              } else {
                // Nếu không phải là phần tử được click, xóa class 'selected'
                menuItem.classList.remove('selected');
              }
            });

            // Lấy giá trị của thuộc tính data-menu từ phần tử <li>
            const targetMenu = item.getAttribute('data-menu');

            // Lấy phần tử cần thêm class dựa trên targetMenu
            const targetElement = document.querySelector(`.${targetMenu}`);

            // Thêm class vào phần tử cần thêm class
            targetElement.classList.add('selected');
          });
        });

        //
        const selectBtn = document.querySelector('.country-select-btn');
        const dropDownItems = document.querySelectorAll('.country-select-drop li');
        let cityWrapper;
        const dropDown = document.querySelector('.country-select-drop');

        selectBtn.addEventListener('click', function() {
          if (dropDown.style.display === 'block') {
            dropDown.style.display = 'none';
          } else {
            dropDown.style.display = 'block';
          }
        });

        document.addEventListener('click', function(event) {
          const target = event.target;

          // Nếu phần tử được click không phải là country-select-btn hoặc country-select-drop, đóng dropdown
          if (target !== selectBtn && target !== dropDown) {
            dropDown.style.display = 'none';
          }
        });

        let hiddenListItems = [];

        // Thêm sự kiện click cho mỗi phần tử <li> trong dropdown menu
        dropDownItems.forEach(function(item) {
          item.addEventListener('click', function() {
            const value = item.getAttribute('value');
            const text = item.textContent;

            // Cập nhật nội dung của thẻ <a> với giá trị và văn bản của phần tử <li> được chọn
            selectBtn.textContent = text;
            selectBtn.setAttribute('value', value);

            // Lọc dữ liệu dựa trên giá trị đã chọn
            const filteredData = data.filter(function(obj) {
              return obj.countryname.toLowerCase().replace(/\s/g, '') === value;
            });

            if (cityWrapper) {
              cityWrapper.remove();
              cityWrapper = null;
            }

            hiddenListItems.forEach(function (listItem) {
              listItem.style.display = 'block';
            });

            // Kiểm tra xem có dữ liệu để tạo cityWrapper không
            if (filteredData.length > 0) {
              cityWrapper = createCustomSelectWrapper('city');
              createCitySelectWrapper(filteredData);

              const mappedValues = getMappedValues(value);
              showItemByCountry(mappedValues);
            } else {
                // Nếu không có dữ liệu, xóa cityWrapper nếu tồn tại
                const listGroupItems = document.querySelectorAll('.list-group-item');
                listGroupItems.forEach(function (listItem) {
                  listItem.style.display = 'block';
                });
            }

          });
        });

        // Hàm tạo custom-select-wrapper cho cityname
        function createCitySelectWrapper(data) {
          // Xóa các tùy chọn cũ trong cityWrapper (nếu có)
          const dropDown = cityWrapper.querySelector('.city-select-drop');
          dropDown.style.display = 'none';
          dropDown.innerHTML = '';

          // Thêm các tùy chọn mới cho cityWrapper
          data.forEach(function(obj) {
            const cityOption = document.createElement('li');
            cityOption.textContent = obj.cityname;
            cityOption.setAttribute('value', obj.cityname.toLowerCase().replace(/\s/g, ''));
            dropDown.appendChild(cityOption);
          });

          // Nếu cityWrapper chưa được append vào tài liệu, append nó vào body
          if (!document.contains(cityWrapper)) {
            filterForm.appendChild(cityWrapper);
          }

          const cityDropDownItems = document.querySelectorAll('.city-select-drop li');
          const citySelectBtn = document.querySelector('.city-select-btn');

          cityDropDownItems.forEach(function(item) {
            item.addEventListener('click', function() {
              const value = item.getAttribute('value');
              const text = item.textContent;

              // Cập nhật nội dung của thẻ <a> với giá trị và văn bản của phần tử <li> được chọn
              citySelectBtn.textContent = text;
              citySelectBtn.setAttribute('value', value);

              // console.log(mappedValues, 'mappedValues');
              const selectedCountry = selectBtn.getAttribute('value');
              const selectedCity = citySelectBtn.getAttribute('value');

              hiddenListItems.forEach(function (listItem) {
                listItem.style.display = 'block';
              });

              // Tìm kiếm trong dataObjects và lấy mảng các giá trị map
              const mappedValues = data.filter(function (obj) {
                  return obj.countryname.toLowerCase().replace(/\s/g, '') === selectedCountry &&
                      obj.cityname.toLowerCase().replace(/\s/g, '') === selectedCity;
              }).map(function (obj) {
                  return obj;
              });

              showItemByCity(mappedValues);
            });
          });
        }

        function showItemByCountry(mappedValues) {
          const listGroupItems = document.querySelectorAll('.list-group-item');
          listGroupItems.forEach(function (listItem) {
              const fullAddressText = listItem.querySelector('.full_address').textContent;
              const matched = mappedValues.some(function (value) {
                  return fullAddressText.includes(value.countryname);
              });
              if (!matched) {
                  listItem.style.display = 'none';
                  hiddenListItems.push(listItem);
              }
          });
        }

        function showItemByCity(mappedValues) {
          const listGroupItems = document.querySelectorAll('.list-group-item');
          listGroupItems.forEach(function (listItem) {
              const fullAddressText = listItem.querySelector('.full_address').textContent;
              const matched = mappedValues.some(function (value) {
                  return fullAddressText.includes(value.countryname) && fullAddressText.includes(value.cityname);
              });
              if (!matched) {
                  listItem.style.display = 'none';
                  hiddenListItems.push(listItem);
              }
          });
        }

        // Hàm lọc dữ liệu dựa trên quốc gia đã chọn và trả về mảng các giá trị map
        function getMappedValues(selectedCountry) {
          // Lọc dữ liệu từ dataObjects dựa trên quốc gia đã chọn
          const filteredData = data.filter(function (obj) {
              return obj.countryname.toLowerCase().replace(/\s/g, '') === selectedCountry;
          });

          // Ánh xạ dữ liệu lọc được sang mảng các giá trị map
          const mappedValues = filteredData.map(function (obj) {
              return obj;
          });

          return mappedValues;
        }

        // Hàm tạo custom-select-wrapper
        function createCustomSelectWrapper(type) {
          const wrapper = document.createElement('div');
          wrapper.classList.add(type+'-select-wrapper');

          const citySelectBtn = document.createElement('a');
          citySelectBtn.classList.add(type+'-select-btn');
          citySelectBtn.textContent = type === 'country' ? 'Destination' : 'City';
          wrapper.appendChild(citySelectBtn);

          // Thêm sự kiện click cho thẻ <a> (nếu cần)
          citySelectBtn.addEventListener('click', function() {
            const cityDropDown = citySelectBtn.nextElementSibling;

            if (cityDropDown.style.display === 'block') {
              cityDropDown.style.display = 'none';
            } else {
              cityDropDown.style.display = 'block';
            }
          });

          // Tạo custom-select-drop (nếu cần)
          const customSelectDrop = document.createElement('ul');
          customSelectDrop.classList.add(type+'-select-drop');
          // Thêm các tùy chọn vào customSelectDrop (nếu cần)
          wrapper.appendChild(customSelectDrop);

          document.addEventListener('click', function(event) {
            const target = event.target;

            // Nếu phần tử được click không phải là country-select-btn hoặc custom-select-drop, đóng dropdown
            if (target !== citySelectBtn) {
              customSelectDrop.style.display = 'none';
            }
          });

          return wrapper;
        }

      } else {
        console.error('Error:', xhr.statusText);
      }
    };

    // Xử lý sự kiện khi có lỗi
    xhr.onerror = function () {
      console.error('Request failed');
    };

    // Gửi yêu cầu với dữ liệu form-data
    xhr.send(formData);
  });
}

document.addEventListener("DOMContentLoaded", function() {
  const sendButton = document.getElementById("sendButton");

  if(sendButton) {
    sendButton.addEventListener("click", function() {
      // Kiểm tra tất cả các trường của form
      const subjectField = document.getElementById("ContactForm-subject");
      const nameField = document.getElementById("ContactForm-name");
      const emailField = document.getElementById("ContactForm-email");
      const bodyField = document.getElementById("ContactForm-body");

      // Kiểm tra xem tất cả các trường đã được nhập đúng cách chưa
      const isValid = validateForm(subjectField, nameField, emailField, bodyField);

      console.log(isValid, 'isValid');
      if (isValid) {
        // Nếu tất cả các trường đã được nhập đúng cách, submit form
        uploadFile();
        // document.getElementById("ContactForm").submit();
      }
    });
  }

  // Hàm để kiểm tra và validate form
  function validateForm(subjectField, nameField, emailField, bodyField) {
    let isValid = true;

    function displayErrorMessage(field, display) {
      const errorMessage = field.parentElement.querySelector('.error-message');
      if (errorMessage) {
        errorMessage.style.display = display ? 'inline' : 'none';
      }
    }

    // Kiểm tra trường subject
    if (subjectField.value.trim() === "") {
      isValid = false;
      subjectField.classList.add('error'); // Thêm lớp 'error'
      displayErrorMessage(subjectField, true);
    } else {
      isValid = true;
      subjectField.classList.remove('error'); // Loại bỏ lớp 'error'
      displayErrorMessage(subjectField, false);
    }

    // Kiểm tra trường name
    if (nameField.value.trim() === "") {
      isValid = false;
      nameField.classList.add('error'); // Thêm lớp 'error'
      displayErrorMessage(nameField, true);
    } else {
      isValid = true;
      nameField.classList.remove('error'); // Loại bỏ lớp 'error'
      displayErrorMessage(nameField, false);
    }

    // Kiểm tra trường email
    if (emailField.value.trim() === "" || !isValidEmail(emailField.value.trim())) {
      isValid = false;
      emailField.classList.add('error'); // Thêm lớp 'error'
      displayErrorMessage(emailField, true);
    } else {
      isValid = true;
      emailField.classList.remove('error'); // Loại bỏ lớp 'error'
      displayErrorMessage(emailField, false);
    }

    // Kiểm tra trường body
    if (bodyField.value.trim() === "") {
      isValid = false;
      bodyField.classList.add('error'); // Thêm lớp 'error'
      displayErrorMessage(bodyField, true);
    } else {
      isValid = true;
      bodyField.classList.remove('error'); // Loại bỏ lớp 'error'
      displayErrorMessage(bodyField, false);
    }

    return isValid;
  }

  // Hàm để kiểm tra email có hợp lệ không
  function isValidEmail(email) {
    // Sử dụng regex để kiểm tra định dạng email
    const emailRegex = /\S+@\S+\.\S+/;
    return emailRegex.test(email);
  }

  function uploadFile() {
    const fileInput = document.getElementById('ContactForm-upload');
    const file = fileInput.files[0];

    if (!file) {
      console.error('No file selected.');
      return;
    }

    // Create a FormData object to send file data
    const formData = new FormData();

    console.log(formData, 'formData');

    formData.append('file', file);

    console.log(fileInput.files[0], 'fileInput');
    console.log(formData, 'fileInput');

    // Send the file to Shopify's Files API
    fetch('https://evisu-hk.myshopify.com/admin/api/2023-07/files.json', {
      method: 'POST',
      headers: {
        'X-Shopify-Access-Token': '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',
      },
      body: formData,
    })
    .then(response => response.json())
    .then(data => {
      console.log('File uploaded successfully:', data);
      const fileUrl = data.file.url; // Extract the file URL from the response
      console.log('File URL:', fileUrl);
      // You can use the file URL as needed (e.g., display it to the user)
    })
    .catch(error => {
      console.error('File upload failed:', error);
    });
  }
});

// Lắng nghe sự kiện khi DOM đã được tải hoàn toàn
document.addEventListener("DOMContentLoaded", function() {
  // Lắng nghe sự kiện khi click vào nút "Scroll to Top"
  document.getElementById("scrollToTopBtn").addEventListener("click", function() {
      // Cuộn trang web lên đầu
      window.scrollTo({
          top: 0,
          behavior: "smooth" // Cuộn mượt
      });
  });

  // Lắng nghe sự kiện cuộn trang
  window.addEventListener("scroll", function() {
      // Nếu người dùng cuộn xuống một khoảng cách nhất định, hiển thị nút "Scroll to Top"
      if (window.scrollY > 300) {
          document.getElementById("scrollToTopBtn").style.display = "block";
      } else {
          document.getElementById("scrollToTopBtn").style.display = "none";
      }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const currentDate = new Date();
  const currentTimestamp = Math.floor(currentDate.getTime() / 1000);
  const elements = document.querySelectorAll('.new-arrivals');

  elements.forEach((element, index) => {
    const newArrivalsStart = element.getAttribute('data-date');

    const thirtyDaysInSeconds = 30 * 24 * 60 * 60; // 30 days in seconds
    const thirtyDaysLaterTimestamp = newArrivalsStart + thirtyDaysInSeconds;
    if (currentTimestamp >= newArrivalsStart && currentTimestamp <= thirtyDaysLaterTimestamp) {
      if (element) {
        element.classList.remove('hidden');
      }
    }
  });
});

//collapsibe
document.addEventListener("DOMContentLoaded", function() {
  const detailsSummaries = document.querySelectorAll("details summary");

  if(detailsSummaries) {
    detailsSummaries.forEach(summary => {
      summary.addEventListener("click", function() {
        detailsSummaries.forEach(otherSummary => {
          if (otherSummary !== summary && otherSummary.parentElement.open) {
            otherSummary.parentElement.open = false;
          }
        });
      });
    });
  }
});

//New store locator
// Kiểm tra xem URL có chứa chuỗi 'a/storelocator' hay không
if (currentURL.includes('pages/store-locator')) {
  // Thực hiện các thao tác JavaScript ở đây
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelector('.multicolumn').style.display = 'none';
    document.querySelector('section.shopify-section-group-footer-group').style.display = 'none';
    document.querySelector('div.shopify-section-group-footer-group').style.display = 'none';

    // Tạo đối tượng FormData và thêm dữ liệu cần gửi
    const formData = new FormData();
    formData.append('shopData', 'evisu-tw.myshopify.com');

    // Tạo đối tượng XMLHttpRequest
    const xhr = new XMLHttpRequest();

    // Thiết lập phương thức và URL
    xhr.open('GET', 'https://sl.storeify.app/js/stores/evisu-tw.myshopify.com/storeifyapps-storelocator-geojson.js', true);

    // Xử lý sự kiện khi yêu cầu hoàn thành
    xhr.onload = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        // Xử lý response ở đây
        // console.log(xhr.responseText, 'responseText');
         // Xử lý response ở đây
        const response = xhr.responseText;
        var startIndex = response.indexOf('{');
        var endIndex = response.lastIndexOf('}');

        // Cắt bỏ phần bọc
        var jsonData = response.slice(startIndex, endIndex + 1);

        // Phân tích chuỗi JSON
        var data = JSON.parse(jsonData);

        // Trích xuất dữ liệu features
        var features = data.features;

        // In ra dữ liệu features

        const searchContentElement = document.querySelector('.storeifyapps-storelocator-equal');

        const htmlSearchMenu =  '<ul id="search-menu">' +
                                  '<li class="search_filter" data-menu="filter-group">Filter</li>' +
                                  '<li class="search_keyword" data-menu="store_search">Search</li>'+
                                  '<li class="search_nearby selected" data-menu="nearby_form">Nearby</li>' +
                                '</ul>';
        const htmlSearchForm =  '<div id="search-form">' +
                                  '<div class="filter_form search_form" id="filter-group"><div class="country-select-wrapper"></div></div>' +
                                  '<div class="nearby_form search_form open" id="nearby_form"><button type="button" id="search_nearby_button">Search Nearby Stores</button></div>' +
                                '</div>';

        searchContentElement.insertAdjacentHTML('afterbegin', htmlSearchForm);
        searchContentElement.insertAdjacentHTML('afterbegin', htmlSearchMenu);

        const searchNearbyButton = document.getElementById("search_nearby_button");
        const findMyLocationLink = document.getElementById("getbylocal");
        const inputAddress = document.getElementById("address");
        const submitButton = document.getElementById("submit-search");

        if (!inputAddress.value) {
          findMyLocationLink.click();
        }

        var selectElement = document.querySelector('.chose-search-slt');

        // Thêm sự kiện click cho button
        searchNearbyButton.addEventListener("click", function() {
          selectElement.value = 'location';
          selectElement.dispatchEvent(new Event('change'));
          submitButton.click();
        });
        let isClicked = false;
        if (searchNearbyButton && !isClicked) {
          setTimeout(function() {
              searchNearbyButton.click();
              isClicked = true;
          }, 1000);
        }
        const searchMenuItems = document.querySelectorAll('#search-menu li');
        // Lặp qua từng <li> và thêm sự kiện click
        searchMenuItems.forEach(function (item) {
          item.addEventListener('click', function() {
            document.querySelector('#filter-group').classList.remove('open');
            document.querySelector('#store_search').classList.remove('open');
            document.querySelector('#nearby_form').classList.remove('open');

            searchMenuItems.forEach(function(menuItem) {
              // Kiểm tra xem menuItem có phải là phần tử được click hay không
              if (menuItem === item) {
                // Nếu là phần tử được click, thêm class 'selected'
                menuItem.classList.add('selected');
              } else {
                // Nếu không phải là phần tử được click, xóa class 'selected'
                menuItem.classList.remove('selected');
              }
            });

            // Lấy giá trị của thuộc tính data-menu từ phần tử <li>
            const targetMenu = item.getAttribute('data-menu');

            // Lấy phần tử cần thêm class dựa trên targetMenu
            const targetElement = document.querySelector(`#${targetMenu}`);

            // Thêm class vào phần tử cần thêm class
            targetElement.classList.add('open');
            submitButton.style.display = 'none';

            itemInnerClick();

            if (targetMenu == "store_search") {
              submitButton.style.display = 'block';

              //reset store list
              var reset = document.querySelector('.storeifyapp_stores_country_filter');

              reset.value = 'all';

              var event = new Event('change', {
                  bubbles: true,
                  cancelable: true
              });
              reset.dispatchEvent(event);
              // document.getElementById("main-slider-storelocator").classList.add('show');
              //end reset store list
            }

            if (targetMenu == "nearby_form") {
              selectElement.value = 'location';
              selectElement.dispatchEvent(new Event('change'));
              // document.getElementById("#results-slt").style.display = '';
            } else {
              if (targetMenu == "filter-group") {
                selectBtn.textContent = "Destination";
                selectBtn.setAttribute('value', 'destination');
                var element = document.getElementsByClassName('city-select-wrapper')[0];
                if (element) {
                    element.style.display = 'none';
                }
                document.querySelector('#store_search').value = "";
                document.querySelector('#store_search').dispatchEvent(new Event('change'));
                // document.getElementById("main-slider-storelocator").classList.add('show');
              }
              selectElement.value = 'store';
              selectElement.dispatchEvent(new Event('change'));
              submitButton.click();
            }

            //if (targetMenu == "filter-group") {
              // document.querySelector('#store_search').value = "";
              // document.querySelector('#store_search').dispatchEvent(new Event('change'));
              // selectBtn.textContent = "Destination";
              // selectBtn.setAttribute('value', 'destination');
              // var element = document.getElementsByClassName('city-select-wrapper')[0];
              // if (element) {
              //     element.style.display = 'none';
              // }
              // submitButton.click();
            //}
          });
        });

        //Append city and country
        const filterForm = document.querySelector('.filter_form');
        const customSelectWrapper = document.querySelector('.country-select-wrapper');

        const ulElement = document.createElement('ul');
        ulElement.classList.add('country-select-drop');
        ulElement.style.display = 'none';

        // Thêm một li mặc định với giá trị "destination"
        const defaultLiElement = document.createElement('li');
        defaultLiElement.textContent = "Destination";
        defaultLiElement.setAttribute('value', 'destination');
        ulElement.appendChild(defaultLiElement);

        let countryNames = {};
        features.forEach(function (item) {
          if (!countryNames[item.properties.country.toLowerCase().replace(/\s/g, '')]) {
            // Nếu chưa tồn tại, thêm countryname vào đối tượng countryNames
            countryNames[item.properties.country.toLowerCase().replace(/\s/g, '')] = true;

            // Tạo một phần tử li
            const liElement = document.createElement('li');

            // Đặt nội dung của a là countryname
            liElement.textContent = item.properties.country;

            // Đặt giá trị của a là countryname
            liElement.setAttribute('value', item.properties.country.toLowerCase().replace(/\s/g, ''));

            // Thêm li vào ul
            ulElement.appendChild(liElement);
          }
        });

        customSelectWrapper.innerHTML += '<a href="#" class="country-select-btn" tabindex="0">Destination</a>';
        customSelectWrapper.appendChild(ulElement);

        //Show and hode destination
        const selectBtn = document.querySelector('.country-select-btn');
        const dropDownItems = document.querySelectorAll('.country-select-drop li');
        let cityWrapper;
        const dropDown = document.querySelector('.country-select-drop');

        selectBtn.addEventListener('click', function() {
          if (dropDown.style.display === 'block') {
            dropDown.style.display = 'none';
          } else {
            dropDown.style.display = 'block';
          }
        });

        document.addEventListener('click', function(event) {
          const target = event.target;

          // Nếu phần tử được click không phải là country-select-btn hoặc country-select-drop, đóng dropdown
          if (target !== selectBtn && target !== dropDown) {
            dropDown.style.display = 'none';
          }
        });

        let hiddenListItems = [];

        // Thêm sự kiện click cho mỗi phần tử <li> trong dropdown menu
        dropDownItems.forEach(function(item) {
          item.addEventListener('click', function() {
            const value = item.getAttribute('value');
            const text = item.textContent;

            // Cập nhật nội dung của thẻ <a> với giá trị và văn bản của phần tử <li> được chọn
            selectBtn.textContent = text;
            selectBtn.setAttribute('value', value);

            // Lọc dữ liệu dựa trên giá trị đã chọn
            const filteredData = features.filter(function(obj) {
              return obj.properties.country.toLowerCase().replace(/\s/g, '') === value;
            });

            if (cityWrapper) {
              cityWrapper.remove();
              cityWrapper = null;
            }

            hiddenListItems.forEach(function (listItem) {
              listItem.style.display = 'block';
            });

            // Kiểm tra xem có dữ liệu để tạo cityWrapper không
            if (filteredData.length > 0) {
              cityWrapper = createCustomSelectWrapper('city');
              createCitySelectWrapper(filteredData);

              const mappedValues = getMappedValues(value);
              // showItemByCountry(mappedValues);
            } else {
                // Nếu không có dữ liệu, xóa cityWrapper nếu tồn tại
                const listGroupItems = document.querySelectorAll('.item.thumbnail');
                listGroupItems.forEach(function (listItem) {
                  listItem.style.display = 'block';
                });
            }

            // trigger country
            var selectElement = document.querySelector('.storeifyapp_stores_country_filter');
            if (value === 'destination') {
                selectElement.value = 'all';
            } else {
                let found = false;
                for (var i = 0; i < selectElement.options.length; i++) {
                    var optionValue = selectElement.options[i].value.replace(/,/g, '').replace(/\s/g, '').toLowerCase();
                    var liFormattedValue = value.replace(/,/g, '').replace(/\s/g, '').toLowerCase();

                    if (optionValue === liFormattedValue) {
                        selectElement.selectedIndex = i;
                        found = true;
                        break;
                    }
                }

                if (!found) {
                    console.log('No matching option found for:', value);
                }
            }
            setTimeout(function() {
                var event = new Event('change', {
                    bubbles: true,
                    cancelable: true
                });
                selectElement.dispatchEvent(event);
            }, 500);
            //end trigger country
          });
        });

        // Hàm tạo custom-select-wrapper cho cityname
        function createCitySelectWrapper(data) {
          // Xóa các tùy chọn cũ trong cityWrapper (nếu có)
          const dropDown = cityWrapper.querySelector('.city-select-drop');
          dropDown.style.display = 'none';
          dropDown.innerHTML = '';
          var addedCities = {};

          // Thêm các tùy chọn mới cho cityWrapper
          data.forEach(function(obj) {
            if (!addedCities[obj.properties.city]) {
              const cityOption = document.createElement('li');
              cityOption.textContent = obj.properties.city;
              cityOption.setAttribute('value', obj.properties.city.toLowerCase().replace(/\s/g, ''));
              dropDown.appendChild(cityOption);

              // Đánh dấu thành phố là đã được thêm vào dropdown
              addedCities[obj.properties.city] = true;
            }
          });

          // Nếu cityWrapper chưa được append vào tài liệu, append nó vào body
          if (!document.contains(cityWrapper)) {
            filterForm.appendChild(cityWrapper);
          }

          const cityDropDownItems = document.querySelectorAll('.city-select-drop li');
          const citySelectBtn = document.querySelector('.city-select-btn');

          cityDropDownItems.forEach(function(item) {
            item.addEventListener('click', function() {
              const value = item.getAttribute('value');
              const text = item.textContent;

              // Cập nhật nội dung của thẻ <a> với giá trị và văn bản của phần tử <li> được chọn
              citySelectBtn.textContent = text;
              citySelectBtn.setAttribute('value', value);

              // console.log(mappedValues, 'mappedValues');
              const selectedCountry = selectBtn.getAttribute('value');
              const selectedCity = citySelectBtn.getAttribute('value');

              hiddenListItems.forEach(function (listItem) {
                listItem.style.display = 'block';
              });

              // Tìm kiếm trong dataObjects và lấy mảng các giá trị map
              const mappedValues = features.filter(function (obj) {
                  return obj.properties.country.toLowerCase().replace(/\s/g, '') === selectedCountry &&
                      obj.properties.city.toLowerCase().replace(/\s/g, '') === selectedCity;
              }).map(function (obj) {
                  return obj;
              });

              showItemByCity(mappedValues);
            });
          });
        }

        // function showItemByCountry(mappedValues) {
          // const listGroupItems = document.querySelectorAll('.item.thumbnail');
          // listGroupItems.forEach(function (listItem) {
          //     const fullAddressText = listItem.querySelector('.address').textContent;
          //     const matched = mappedValues.some(function (value) {
          //         return fullAddressText.includes(value.properties.country);
          //     });

          //     if (!matched) {
          //         listItem.style.display = 'none';
          //         hiddenListItems.push(listItem);
          //         console.log (hiddenListItems, 'hiddenListItems')

          //     }
          // });
        // }

        function showItemByCity(mappedValues) {
          const listGroupItems = document.querySelectorAll('.item.thumbnail');

          listGroupItems.forEach(function (listItem) {
            const addressLink = listItem.querySelector('.address a');
            const href = addressLink ? addressLink.getAttribute('href') : '';

            const matched = mappedValues.some(function (value) {
              return href.includes(value.properties.country) && href.includes(value.properties.city);
            });

            if (!matched) {
              listItem.style.display = 'none';
              hiddenListItems.push(listItem);
            } else {
              listItem.style.display = 'block';
            }
          });
        }


        function getMappedValues(selectedCountry) {
          // Lọc dữ liệu từ dataObjects dựa trên quốc gia đã chọn
          const filteredData = features.filter(function (obj) {
              return obj.properties.country.toLowerCase().replace(/\s/g, '') === selectedCountry;
          });

          // Ánh xạ dữ liệu lọc được sang mảng các giá trị map
          const mappedValues = filteredData.map(function (obj) {
              return obj;
          });

          return mappedValues;
        }

        // Hàm tạo custom-select-wrapper
        function createCustomSelectWrapper(type) {
          const wrapper = document.createElement('div');
          wrapper.classList.add(type+'-select-wrapper');

          const citySelectBtn = document.createElement('a');
          citySelectBtn.classList.add(type+'-select-btn');
          citySelectBtn.textContent = type === 'country' ? 'Destination' : 'City';
          wrapper.appendChild(citySelectBtn);

          // Thêm sự kiện click cho thẻ <a> (nếu cần)
          citySelectBtn.addEventListener('click', function() {
            const cityDropDown = citySelectBtn.nextElementSibling;

            if (cityDropDown.style.display === 'block') {
              cityDropDown.style.display = 'none';
            } else {
              cityDropDown.style.display = 'block';
            }
          });

          // Tạo custom-select-drop (nếu cần)
          const customSelectDrop = document.createElement('ul');
          customSelectDrop.classList.add(type+'-select-drop');
          // Thêm các tùy chọn vào customSelectDrop (nếu cần)
          wrapper.appendChild(customSelectDrop);

          document.addEventListener('click', function(event) {
            const target = event.target;

            // Nếu phần tử được click không phải là country-select-btn hoặc custom-select-drop, đóng dropdown
            if (target !== citySelectBtn) {
              customSelectDrop.style.display = 'none';
            }
          });

          return wrapper;
        }

        function itemInnerClick() {
          // const mapStyle = document.querySelector('.gm-style');

          // if(!mapStyle) {
          //   return;
          // }

          // const innerItems = mapStyle.querySelectorAll('div[role="button"]');

          // innerItems.forEach(item => {
          //   item.classList.remove('active');

          //   function handleItemClick(event) {
          //     item.classList.add('active');
          //     const storeName = mapStyle.querySelector('.store-name');

          //     var labelText = storeName.textContent;
          //     var innerItems = document.querySelectorAll('.inner-item');

          //     innerItems.forEach(function(innerItem) {
          //         var innerItemText = innerItem.querySelector('.store-name strong').textContent;
          //         innerItem.classList.remove('inner-item-active');

          //         if (innerItemText.includes(labelText)) {
          //             innerItem.classList.add('inner-item-active');
          //             innerItem.scrollIntoView({ behavior: 'smooth' });
          //         }
          //     });
          //   }

          //   item.addEventListener("click", handleItemClick);
          //   item.addEventListener("touchend", handleItemClick);
          // });
        }

        setTimeout(function() {
          itemInnerClick();
        }, 1000)
      }
    };

    function whenReady(cb) {
      if (window.google && google.maps) return cb();
      var t = setInterval(() => {
        if (window.google && google.maps) { clearInterval(t); cb(); }
      }, 100);
    }

    whenReady(function () {
      if (!google.maps.InfoWindow) return;

      const _open = google.maps.InfoWindow.prototype.open;
      google.maps.InfoWindow.prototype.open = function (map, anchor) {
        if (anchor instanceof google.maps.Marker) {
          console.log("Marker triggered InfoWindow:", anchor);
          console.log(anchor.name)

          var div = document.createElement("div");
          div.innerHTML = anchor.name;
          var makerName = div.textContent;
          if (document.documentElement.lang === "en") {
            if(div.querySelector(".en")){
              makerName = div.querySelector(".en").textContent;
            }
          }
          if (document.documentElement.lang === "zh-TW") {
            if(div.querySelector(".zh")){
              makerName = div.querySelector(".zh").textContent;
            }
          }
          if (document.documentElement.lang === "zh-CN") {
            if(div.querySelector(".cn")){
              makerName = div.querySelector(".cn").textContent;
            }
          }
          if (document.documentElement.lang === "ja") {
            if(div.querySelector(".jp")){
              makerName = div.querySelector(".jp").textContent;
            }
          }
          // Custom scroll to active item
          document.querySelectorAll(".inner-item").forEach(innerItem => {
            innerItem.classList.remove("inner-item-active");
          });

          // find and activate the matching inner item
          const match = Array.from(document.querySelectorAll(".inner-item")).find(innerItem => {
            const strong = innerItem.querySelector(".store-name strong");
            var itemName = strong?.textContent;
            if (document.documentElement.lang === "en") {
              if(strong.querySelector(".en")){
                itemName = strong.querySelector(".en").textContent;
              }
            }
            if (document.documentElement.lang === "zh-TW") {
              if(strong.querySelector(".zh")){
                itemName = strong.querySelector(".zh").textContent;
              }
            }
            if (document.documentElement.lang === "zh-CN") {
              if(strong.querySelector(".cn")){
                itemName = strong.querySelector(".cn").textContent;
              }
            }
            if (document.documentElement.lang === "ja") {
              if(strong.querySelector(".jp")){
                itemName = strong.querySelector(".jp").textContent;
              }
            }
            return itemName.includes(makerName);
          });


          if (match) {
            match.classList.add("inner-item-active");
            match.scrollIntoView({ behavior: "smooth" });
          }
        }
        return _open.apply(this, arguments);
      };
    });

    // Xử lý sự kiện khi có lỗi
    xhr.onerror = function () {
      console.error('Request failed');
    };

    // Gửi yêu cầu với dữ liệu form-data
    xhr.send(formData);
  });
}

// Header menu
document.addEventListener("DOMContentLoaded", function() {
  const headerDesktop = document.querySelector('.header-menu-wrapper');
  const headerItems = headerDesktop.querySelectorAll('.header-item');
  const submenuWrappers = headerDesktop.querySelectorAll('.submenu-wrapper');

  headerItems.forEach((headerItem) => {
    headerItem.addEventListener('mouseover', function() {
      var heading = headerItem.getAttribute('data-heading');

      submenuWrappers.forEach(function(submenuWrapper) {
        if (submenuWrapper.getAttribute('data-heading') === heading) {
          submenuWrapper.classList.add('active');
          headerItem.classList.add('active');
        } else {
          submenuWrapper.classList.remove('active');
          headerItems.forEach(function(item) {
            if (item !== headerItem) {
              item.classList.remove('active');
            }
          });
        }
      });
    });

    headerItem.addEventListener('mouseleave', function() {
      submenuWrappers.forEach(function(submenuWrapper) {
        submenuWrapper.classList.remove('active');
        headerItem.classList.remove('active');
      });
    });
  });

  //NEW
  window.addEventListener('resize', () => {
    document.querySelectorAll('.submenu-wrapper.active').forEach(sub => {
      const heading = sub.getAttribute('data-heading');
      const hdr = headerDesktop.querySelector(`.header-item[data-heading="${heading}"]`);
      if (hdr) {
        const topOffset = hdr.offsetTop + hdr.offsetHeight;
        sub.style.top = `${topOffset}px`;
      }
    });
  });

});



//Mobile menu
document.addEventListener("DOMContentLoaded", function() {
  // Hàm cuộn trang đến vị trí của phần tử
  function scrollToTop(element) {
    const containerEl = document.querySelector('.menu-drawer__navigation-container');
    var top = element.getBoundingClientRect().top + containerEl.scrollY - document.querySelector('.menu-drawer__navigation-container').offsetTop;

    console.log(top, 'top');

    containerEl.scrollTo({
      top: top,
      behavior: 'smooth'
    });
  }

  // Hàm cập nhật chiều cao của submenu
  function updateSubmenuHeight(submenu) {
    // submenu.style.height = '0';
    // var height = submenu.scrollHeight + 'px';
    // submenu.style.height = height;

    var clone = submenu.cloneNode(true);
    clone.style.height = 'auto';
    clone.style.visibility = 'hidden';
    clone.style.position = 'absolute';
    document.body.appendChild(clone);
    var height = clone.scrollHeight + 'px';
    document.body.removeChild(clone);

    // Áp dụng chiều cao mới cho submenu
    submenu.style.height = height;
  }

  var menuItems = document.querySelectorAll('.mobile-menu-item');

  // Toggle Submenu on Header Item Click
  menuItems.forEach(function(menuItem) {
    var headerItem = menuItem.querySelector('.mobile-header-item');
    var submenuWrapper = menuItem.querySelector('.mobile-submenu-wrapper');

    headerItem.addEventListener('click', function() {
      if (headerItem.classList.contains('active')) {
        headerItem.classList.remove('active');
        submenuWrapper.classList.remove('active');
        submenuWrapper.style.height = '0';
        menuItem.classList.remove('active');
      } else {
        document.querySelectorAll('.mobile-menu-item').forEach(function(item) {
          var itemHeader = item.querySelector('.mobile-header-item');
          var itemSubmenu = item.querySelector('.mobile-submenu-wrapper');
          if (item !== menuItem) {
            item.classList.add('blur');
            item.classList.remove('active');
            itemHeader.classList.remove('active');
            itemSubmenu.classList.remove('active');
            itemSubmenu.style.height = '0';
          } else {
            item.classList.remove('blur');
            item.classList.add('active');
            itemHeader.classList.add('active');
            itemSubmenu.classList.add('active');
            // scrollToTop(itemHeader);
            updateSubmenuHeight(itemSubmenu);
          }
        });
      }

      // Check if any headerItem has class 'active'
      var anyActiveHeaderItem = document.querySelector('.mobile-header-item.active');
      if (!anyActiveHeaderItem) {
        document.querySelectorAll('.mobile-menu-item').forEach(function(item) {
          item.classList.remove('blur');
          item.classList.remove('active');
        });

        document.querySelector('.menu-drawer__navigation-container').classList.remove('active');
      } else {
        document.querySelector('.menu-drawer__navigation-container').classList.add('active');
      }
    });
  });

  function toggleHideBanner(wrapper) {
    if (!wrapper) return;
    const hasAnyActive = wrapper.querySelector('.list-menu-mobile__item-title.active') !== null;
    wrapper.classList.toggle('hide-banner', hasAnyActive);
  }
  document.querySelectorAll('.mobile-submenu-wrapper').forEach(toggleHideBanner);

  // Toggle submenu on list-menu-mobile__item-title click
  document.querySelectorAll('.list-menu-mobile__item-title').forEach(menuItem => {
    var hasSubmenu = menuItem.nextElementSibling;

    menuItem.addEventListener('click', function(event) {
      event.preventDefault();

      if (menuItem.classList.contains('active')) {
        menuItem.classList.remove('active');
        if (hasSubmenu && hasSubmenu.classList.contains('mobile__has-submenu')) {
          hasSubmenu.classList.remove('active');
        }
      } else {
        document.querySelectorAll('.list-menu-mobile__item-title').forEach(function(item) {
          item.classList.remove('active');
          var submenu = item.nextElementSibling;
          if (submenu && submenu.classList.contains('mobile__has-submenu')) {
            submenu.classList.remove('active');
          }
        });

        menuItem.classList.add('active');
        if (hasSubmenu && hasSubmenu.classList.contains('mobile__has-submenu')) {
          hasSubmenu.classList.add('active');
        }
      }

      // Cập nhật chiều cao của submenu-wrapper mỗi khi click
      var parentMenuItem = menuItem.closest('.mobile-menu-item');
      var itemSubmenu = parentMenuItem.querySelector('.mobile-submenu-wrapper');
      updateSubmenuHeight(itemSubmenu);

      toggleHideBanner(itemSubmenu);
    });
  });

  (function () {
    const header = document.querySelector('sticky-header');
    const drawer = document.getElementById('menu-drawer');
    if (!header || !drawer) return;

    function applyTop() {
      const h = Math.round(header.getBoundingClientRect().height);
      drawer.style.top = h + 'px';
    }

    let t1, t2;
    function onResize() {
      clearTimeout(t1); clearTimeout(t2);
      t1 = setTimeout(applyTop, 50);
      t2 = setTimeout(applyTop, 300);
    }

    window.addEventListener('DOMContentLoaded', applyTop);
    window.addEventListener('load', applyTop);
    window.addEventListener('resize', onResize);

  })();


  // Hàm cập nhật class active cho các collection-item a và menu-image a
  function updateActiveLinks(selector) {
    var currentUrl = window.location.href;
    var items = document.querySelectorAll(selector);

    items.forEach(function(item) {
      if (item.href && item.href === currentUrl) {
        item.classList.add('menu--active');
      } else {
        item.classList.remove('menu--active');
      }
    });
  }

  updateActiveLinks('.collection-item a');
  updateActiveLinks('.menu-image a');

  function activeMenuDesktop(items) {
    const menuListItems = document.querySelectorAll(items);

    menuListItems.forEach(item => {
      item.addEventListener('mouseenter', function(event) {
        menuListItems.forEach(i => {
          if (i === event.currentTarget) {
            i.classList.add('-active');
          } else {
            i.classList.add('-disable');
          }
        });
      });

      item.addEventListener('mouseleave', function() {
        menuListItems.forEach(i => {
          i.classList.remove('-active', '-disable');
        });
      });
    });
  }

  activeMenuDesktop('.collection-item');
  activeMenuDesktop('.list-submenu__item-desktop');
  activeMenuDesktop('.menu-image-title');
  activeMenuDesktop('.list-menu__item-title');
});
document.addEventListener('DOMContentLoaded', function () {
  var cartPopup = document.getElementById('cart-popup');
  var cartPopupClose = document.getElementById('cart-popup-close');
  if(!cartPopupClose) return;
  cartPopupClose.addEventListener('click', function () {
      cartPopup.style.display = 'none';
  });
});

function extractCodeAndSuffixFromUrl(url) {
    if (!url) {
        console.error('URL is undefined or null');
        return { code: '', suffix: '' };
    }

    let pattern = /-([A-Z]+)_(m?\d+)_/i;
    let match = url.match(pattern);

    if (match && match[1]) {
        const code = match[1];
        const suffix = match[2];
        return { code, suffix };
    } else {
        pattern = /-([A-Z]+)_(\w+)\.jpg/i;
        match = url.match(pattern);
        if (match && match[1]) {
            const code = match[1];
            const suffix = match[2];
            return { code, suffix };
        } else {
            return { code: '', suffix: '' };
        }
    }
}
function findImage(images, code, suffix) {
    const primaryPattern = new RegExp(`${code}_1`, 'i');
    const secondaryPattern = new RegExp(`${code}_2`, 'i');
    const tertiaryPattern = new RegExp(`${code}_3`, 'i');
    let image
    // Try to find an image that matches the primary pattern
    if(suffix != "1"){
      image = images.find(img => primaryPattern.test(img));
    }

    // If no image is found, try the secondary pattern
    if (!image) {
      image = images.find(img => secondaryPattern.test(img));
    }

    // If no image is found, try the tertiary pattern
    if (!image) {
      image = images.find(img => tertiaryPattern.test(img));
    }
    return image;
  }
